// extracted by mini-css-extract-plugin
module.exports = {"sidebar_logo_conponent":"Sidebar_sidebar_logo_conponent__o3FWG"};